import { Component, Input } from "@angular/core";
import { MemorialService } from "administrativo-lib";
import { AssinaturaService, BaseResourceRptPersonalizadoComponent, CpfPipe, Licitacao, LicitacaoPipe, Memorial, PregaoHistorico, Proposta } from "eddydata-lib";
import { takeUntil } from "rxjs/operators";
import * as toastr from 'toastr';
import { PregaoHistoricoService } from "../../licitacao/service/pregao-historico.service";

declare var $: any;

@Component({
  selector: 'app-ata-personalizada-rpt',
  templateUrl: './ata-personalizada-rpt.component.html'
})
export class AtaPersonalizadaRptComponent extends BaseResourceRptPersonalizadoComponent {

  @Input() public licitacao: Licitacao;

  constructor(
    private historicoService: PregaoHistoricoService,
    protected memorialService: MemorialService,
    protected assinaturaService: AssinaturaService,
  ) {
    super(assinaturaService);
    this.assinaturaObrigatoria = false;
  }

  protected afterInit(): void {
  }

  protected modalRelatorio(): string {
    return 'dialogRelatorioAtaPersonalizada';
  }

  protected tituloRelatorio(): string {
    return 'Ata de Sessão Pública';
  }

  protected layoutRelatorio(): {} {
    return {
      table_eddy: {
        hLineWidth: function (i, node) {
          return i === 0 ? 0 : 1;
        },
        vLineWidth: function (i) {
          return 0;
        },
        hLineColor: function (i, node) {
          return i === node.table.headerRows ? 'black' : '#eee';
        },
        paddingLeft: function (i) {
          return i === 0 ? 0 : 8;
        },
        paddingRight: function (i, node) {
          return (i === node.table.widths.length - 1) ? 0 : 8;
        },
        fillColor: function (i, node) {
          if (i === 0 || i === node.table.headerRows) {
            return null;
          }
          return (i % 2 === 0) ? '#f5f5f5' : null;
        }
      }
    }
  }

  protected async montarConteudo(): Promise<{}[]> {
    let modelo: string = this.licitacao.modelo_ata ? this.licitacao.modelo_ata : this.licitacao.modalidade.modelo_ata;
    if (!modelo) {
      toastr.warning('Nenhum modelo encontrado para impressão da ata');
      return;
    }
    modelo = this.substituirTagsConteudo(modelo);

    const conteudo = [];
    return await new Promise(async (resolve) => {
      conteudo.push({
        text: `${this.licitacao.modalidade.nome} Nº ${new LicitacaoPipe().transform(this.licitacao.numero)}`, alignment: 'center',
        bold: true, fontSize: 16, decoration: 'underline', margin: [0, 0, 0, 10]
      })

      for (let i = 0; i < modelo.split('\n').length; i++) {
        const paragrafo = modelo.split('\n')[i];

        if (paragrafo === '<MEMORIAL>') {
          conteudo.push(await this.dadosItens())
        } else if (paragrafo === '<HISTORICO>') {
          conteudo.push(await this.dadosHistorico())
        } else if (paragrafo === '<ASSINATURAS>') {
          conteudo.push(this.dadosRodape())
        } else {
          conteudo.push({ text: paragrafo, fontSize: 10, alignment: 'justify', margin: [0, 0, 0, 10] })
        }
      }

      resolve(conteudo);
    })
  }

  public abrirModelo() {
    $('#dialogRelatorioAtaPersonalizada').modal('hide');
    $('#dialogModeloAta').modal('show');
  }

  public callbackModelo(modelo: string) {
    if (modelo) {
      this.licitacao.modelo_ata = modelo;
    }
    $('#dialogRelatorioAtaPersonalizada').modal('show');
  }

  private substituirTagsConteudo(modelo: string): string {
    return modelo
      .split('<DATA_JULGAMENTO>').join(this.funcaoService.converteDataBR(this.licitacao.data_julgamento))
      .split('<HORA_JULGAMENTO>').join(this.funcaoService.converteHoraBR(this.licitacao.data_julgamento))
      .split('<MODALIDADE>').join(this.licitacao.modalidade.nome)
      .split('<NUMERO>').join(new LicitacaoPipe().transform(this.licitacao.numero))
      .split('<OBJETO>').join(this.licitacao.objeto)
      .split('<PROCESSO>').join(new LicitacaoPipe().transform(this.licitacao.processo))
  }

  private async dadosItens(): Promise<{}[]> {
    const conteudo: {}[] = []

    return await new Promise((resolve) => {
      this.memorialService.obterPorLicitacao(this.licitacao.id, true).pipe(takeUntil(this.unsubscribe))
        .subscribe((res) => {
          const reg: Memorial[] = res.content;

          reg.forEach(memorial => {
            conteudo.push({ text: `Item: ${memorial.ordem}`, bold: true, fontSize: 10, margin: [0, 10, 0, 5] })
            conteudo.push({
              fontSize: 10, margin: [0, 0, 0, 5],
              text: [
                { text: 'Descrição: ', bold: true }, { text: memorial.descricao }
              ]
            })
            conteudo.push({
              fontSize: 10, margin: [0, 0, 0, 5],
              columns: [
                {
                  text: [{ text: 'Unidade de Fornecimento: ', bold: true }, { text: memorial.unidade }]
                },
                {
                  text: [{ text: 'Quantidade: ', bold: true }, { text: this.funcaoService.convertToBrNumber(memorial.quantidade, 0) }]
                }
              ]
            })
            conteudo.push({
              fontSize: 10, margin: [0, 0, 0, 5],
              columns: [
                {
                  text: [{ text: 'Margem de Preferência: ', bold: true }, { text: 'Não' }]
                },
                {
                  text: [{ text: `Intervalo mínimo entre lances (${memorial.reducao_criterio}): `, bold: true }, { text: this.funcaoService.convertToBrNumber(memorial.reducao_lance, 4) }]
                }
              ]
            })
            const vencedor: Proposta = memorial.propostas.find(p => p.situacao === 'VENCEDOR');
            if (vencedor) {
              conteudo.push({
                fontSize: 10, margin: [0, 10, 0, 5],
                text: [
                  { text: 'Vencido por ', bold: true }, { text: vencedor.proponente.favorecido.nome },
                  { text: ' pelo melhor lance de ', bold: true }, { text: this.funcaoService.convertToBrNumber(vencedor.valor_final, 4) },
                ]
              })
            }
          })
          resolve(conteudo)
        });
    })
  }

  private async dadosHistorico(): Promise<{}[]> {
    return await new Promise((resolve) => {
      this.memorialService.obterPorLicitacao(this.licitacao.id, true).pipe(takeUntil(this.unsubscribe))
        .subscribe(async (res) => {
          const reg: Memorial[] = res.content;

          const conteudo = []
          conteudo.push({ text: 'Histórico', alignment: 'center', fontSize: 12, bold: true, margin: [0, 15, 0, 5] })

          for (let i = 0; i < reg.length; i++) {
            const memorial = reg[i];

            conteudo.push({ text: `Item: ${memorial.ordem} - ${memorial.descricao}`, bold: true, fontSize: 10, margin: [0, 15, 0, 5] })
            conteudo.push({
              fontSize: 10, margin: [0, 0, 0, 5], columns: [
                {
                  text: [{ text: 'Unidade de Fornecimento: ', bold: true }, { text: memorial.unidade }]
                },
                {
                  text: [{ text: 'Quantidade: ', bold: true }, { text: this.funcaoService.convertToBrNumber(memorial.quantidade, 0) }]
                }
              ]
            })

            const propostas = await this.dadosPropostas(memorial);
            conteudo.push({ text: 'Propostas', alignment: 'left', fontSize: 10, bold: true, margin: [0, 10, 0, 5] })
            conteudo.push(propostas);

            const lances = await this.dadosLances(memorial);
            conteudo.push({ text: 'Lances', alignment: 'left', fontSize: 10, bold: true, margin: [0, 10, 0, 5] })
            conteudo.push(lances);
          }

          resolve(conteudo)
        });
    })
  }

  private async dadosPropostas(memorial: Memorial): Promise<{}> {
    const tabela: {}[] = [];
    tabela.push(
      [
        { text: 'Favorecido', alignment: 'left', fontSize: 9 },
        { text: 'Marca', alignment: 'left', fontSize: 9 },
        { text: 'Valor Unit.', alignment: 'center', fontSize: 9 },
        { text: 'Valor Total', alignment: 'center', fontSize: 9 },
      ],
    )
    return await new Promise((resolve) => {
      memorial.propostas.forEach(p => {
        tabela.push(
          [
            { text: `${new CpfPipe().transform(p.proponente.favorecido.cpf_cnpj)} - ${p.proponente.favorecido.nome}`, alignment: 'left', fontSize: 8 },
            { text: `${p.marca}`, alignment: 'left', fontSize: 8 },
            { text: `${this.funcaoService.convertToBrNumber(p.valor_unitario, 4)}`, alignment: 'right', fontSize: 8 },
            { text: `${this.funcaoService.convertToBrNumber(+memorial.quantidade * +p.valor_unitario, 4)}`, alignment: 'right', fontSize: 8 },
          ],
        )
      })

      resolve({
        layout: 'table_eddy',
        table: {
          dontBreakRows: true,
          headerRows: 1,
          widths: ['*', 100, 50, 65],
          body: tabela
        }
      })
    })
  }

  private async dadosLances(memorial: Memorial): Promise<{}> {
    const tabela: {}[] = [];
    tabela.push(
      [
        { text: 'Horário', alignment: 'left', fontSize: 9 },
        { text: 'Descrição', alignment: 'left', fontSize: 9 },
        { text: 'Favorecido', alignment: 'left', fontSize: 9 },
        { text: 'Rodada', alignment: 'left', fontSize: 9 },
        { text: 'Lance', alignment: 'left', fontSize: 9 },
        { text: 'Valor', alignment: 'center', fontSize: 9 },
      ],
    )
    return await new Promise((resolve) => {
      this.historicoService.obterPorItem(memorial.id).pipe(takeUntil(this.unsubscribe))
        .subscribe((res) => {
          const reg: PregaoHistorico[] = res.content;
          for (let i = 0; i < reg.length; i++) {
            const h = reg[i];
            tabela.push(
              [
                { text: `${this.funcaoService.converteDataHoraBR(h.data_cadastro)}`, alignment: 'left', fontSize: 8 },
                { text: `${h.descricao}`, alignment: 'left', fontSize: 8 },
                { text: `${new CpfPipe().transform(h.lance.proponente.favorecido.cpf_cnpj)}`, alignment: 'left', fontSize: 8 },
                { text: `${h.lance.lance}`, alignment: 'center', fontSize: 8 },
                { text: `${h.lance.rodada}`, alignment: 'center', fontSize: 8 },
                { text: `${this.funcaoService.convertToBrNumber(h.lance.valor, 4)}`, alignment: 'right', fontSize: 8 },
              ],
            )
          }

          resolve({
            layout: 'table_eddy',
            table: {
              dontBreakRows: true,
              headerRows: 1,
              widths: ['auto', '*', '*', 'auto', 'auto', 'auto'],
              body: tabela
            }
          })
        })
    })
  }

  private dadosRodape(): {}[] {
    let assinaturas = [];
    if (this.assinatura) {
      assinaturas = this.assinatura.pessoas.filter(p => p.selecionado);
      if (assinaturas?.length === 0) return [{}];
    }

    const conteudo: {}[] = [
      { text: this.funcaoService.formatarDataExtenso(new Date(), this.login.cidade.nome), alignment: 'center', fontSize: 10, margin: [0, 30, 0, 70] },
    ]

    return conteudo.concat(this.imprimirAssinaturas(assinaturas));
  }

}